'use strict';

namespace Insurance {
    class InsuranceResults {

        insuranceQuotes: Core.Insurance.InsuranceQuote[];
        summary;
        typeSummary;
        documentPaths;
        selectPolicy;

        constructor(
            private $location: ng.ILocationService,
            private resourceService: Core.ResourceService,
            private $scope: ng.IScope,
            private tripService: Core.TripService,
            private $routeParams,
            private insuranceService,
            private broker: Core.Broker,
            private basketService,
            private $q: ng.IQService,
            private analytics
        ) {
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGINSURANCE'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-insuranceSearchCtrl'
            });

            analytics.track('mixpanel', 'TransferPage');

            tripService.getTrip($routeParams.tripId).then(trip => {
                const insuranceReq = trip && trip.InsuranceRequest;
                if (insuranceReq) {
                    const searchId = insuranceReq.AvailabilitySearchId;

                    this.$q.all([
                        insuranceService.getSearchResults(searchId, trip.TripId),
                        tripService.getInsuranceRequestSummary($routeParams.tripId)
                    ]).then(results => {
                        this.insuranceQuotes = results[0];
                        this.summary = results[1];
                        this.typeSummary = this.summary && this.summary.Destination && this.summary.PolicyType ?
                            this.summary.PolicyType.Name + ' - '
                            + this.summary.Destination.Name + ' - ' : '';
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                        });

                    this.selectPolicy = function (policy) {
                        const data = {
                            Title: policy.QuoteType.Type,
                            CostTotal: policy.Price,
                            TotalOptions: this.insuranceQuotes.length,
                            SupplierName: policy.SupplierName
                        };
                        analytics.track('mixpanel', 'OptionsInsuranceSelected', data);
                        basketService.selectInsurance(policy, searchId, trip.BasketId, trip.TripId);
                        this.selectedInsurance = policy;
                    };

                    this.documentPaths = insuranceService.getDocumentPaths();
                }
            });
        }
    }

    angular.module('insurance')
        .controller('InsuranceResults', InsuranceResults);
}
